import { Outlet } from 'react-router-dom';
import BottomNav from '@/components/feature/BottomNav';

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-background-50 pb-16">
      <main className="max-w-lg mx-auto px-4">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}